import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import { FormControl, Grid, InputLabel, MenuItem, Select } from '@material-ui/core';
import CustomTypo from '../../components/CustomTypo';
import t from '../../utils/translateUtil';
import DrawerCustom from '../../components/DrawerCustom';
import CustomizedCircularProgress from '../../components/CircularProgress';
import InfiniteScroll from 'react-infinite-scroll-component';
import ButtonCustom from '../../components/ButtonCustom';
import { custom_assets, domainName } from '../../../portal.config';
import { portalCfg } from '../../../portal.router.config';
import { DowngradeIcon, UpgradeIcon } from '../../components/icons';
import { Currencies } from '../../../Currencies';
import { getCurrencySymbol } from '../../utils/util';
import classNames from 'classnames';
import { sortPrice } from '../../utils/common';

const drawerWidth = 520;
var path = custom_assets[domainName] && custom_assets[domainName].customImage && custom_assets[domainName].customImage.logo ? portalCfg.publicPath + "/custom_assets" : portalCfg.publicPath + "/assets";


const styles = theme => ({
    container: {
        // borderWidth:1,
        borderRadius: 10,
        backgroundColor: theme.palette.background.box,
        padding: theme.spacing(2),
        marginBottom: theme.spacing(16),
        // height: 230,
    },
    item: {
        // width: 200,
        // height: 200,
        marginLeft: '5%',
        marginRight: '5%',
        border: '1px solid',
        borderColor: theme.palette.border.primary,
        // justifyContent: 'center',
        alignItems: 'center',
        borderRadius: theme.spacing(3),
        cursor: 'pointer',
        background: theme.palette.background.secondary,
        marginBottom: theme.spacing(3),
        padding: theme.spacing(1, 2),
    },
    item_image: {
        // height: 100,
        padding: theme.spacing(3, 0),
        borderTopLeftRadius: 4,
        borderTopRightRadius: 4,
        textAlign: 'center',
        // marginTop: 8,
    },
    item_name: {
        padding: theme.spacing(1.5, 0)
    },
    icon: {
        padding: theme.spacing(3),
        textAlign: 'right',
    },
    priceItem: {
        padding: theme.spacing(1),
        borderRadius: theme.spacing(1),
        // backgroundColor: theme.palette.background.primary,
        border: '1px solid ' + theme.palette.border.primary,
    },
    priceItemSelected: {
        backgroundColor: theme.palette.background.primary,
    },
    selectPrices: {
        padding: theme.spacing(2),
    },
    formControl: {
        width: '100%',
    },
});

function ProductsView(props) {
    const { classes, t, listProducts, showLoading, handleLoadMore, hasMore, showLoadMore, onClickDetail } = props;
    console.log("listProducts===", listProducts);
    return (
        <DrawerCustom
            open={props.open}
            onClose={props.onClose}
            title={t('products_tier')}
            large={true}
            children={
                <Grid item>
                    <Grid item container justify='center' alignItems='center'>
                        {showLoading && <CustomizedCircularProgress />}
                    </Grid>
                    {listProducts && <Grid xs={12} item>
                        <InfiniteScroll
                            dataLength={listProducts.length} //This is important field to render the next data
                            next={handleLoadMore}
                            hasMore={hasMore}
                            loader={showLoadMore ? <CustomizedCircularProgress /> : <h4>{""}</h4>}
                            height={window.innerHeight}
                        >
                            <Grid xs={12} item container className={classes.item_list}>
                                {listProducts.map((item, index) => (
                                    <Grid item xs={12} sm={6} key={index}>
                                        <ProductItem
                                            classes={classes}
                                            key={index}
                                            product={item}
                                            currency={props.currency}
                                            onClickDetail={onClickDetail}
                                        />
                                    </Grid>
                                )
                                )}
                            </Grid>
                        </InfiniteScroll>
                    </Grid>}
                </Grid>
            } />
    );
}

function ProductItem(props) {
    var { classes, product } = props;
    let prices = product.prices && product.prices.length > 0 ? product.prices.sort(sortPrice) : null;
    const [priceSelected, setPriceSelected] = useState(prices && prices.length > 0 ? prices[0] : null);

    return (
        <Grid item xs={12} className={classes.item} data-change-service-product-id={"product_id_" + product.id} data-change-service-product-name={product.name}>
            <Grid item xs={12} className={classes.icon}>
                <Grid item xs={12} justifyContent='flex-end'>
                    {product && product.change_type === 'DOWNGRADE' ? <DowngradeIcon /> : <UpgradeIcon />}
                </Grid>
            </Grid>
            <Grid item className={classes.item_image}>
                {/* <ProductImage classes={classes} image={dataUtil.getImageByUsageTypePortal(product.creatives, usage_type.product_item)} /> */}
                <img src={path + '/images/logo.png'} alt={product.name} style={{height: 100, borderTopLeftRadius: 4, borderTopRightRadius: 4, objectFit: 'contain' }}></img>
            </Grid>
            <Grid item className={classes.item_name}>
                <CustomTypo variant='subtitle2' center>{product.name}</CustomTypo>
            </Grid>            
            <Grid item xs={12} container alignItems='center' justifyContent='center'>
                {prices && prices.length > 0 && prices.map((item, index) => {
                    return (
                        <Grid item xs={6} sm={12} md={6} lg={4} style={{ padding: 4}} key={index} onClick={() => setPriceSelected(item)}>
                            <PriceItem 
                                t={t}
                                classes={classes}
                                price={item}
                                priceSelected={priceSelected}
                            />
                        </Grid>
                    );
                })}
            </Grid>
            <Grid item xs={12} container justifyContent='center' style={{ paddingBottom: 10, paddingTop: 10}}>
                <ButtonCustom fullWidth size="sm" color={"primary"} onClick={() => props.onClickDetail(product, priceSelected)}>{t('select_title')}</ButtonCustom>
            </Grid>
        </Grid>
    )
}
function PriceItem(props){
    const { price, t, classes, priceSelected } = props;
    var price_terms = price && price.price_terms ? price.price_terms : null;
    console.log("price_terms===", price_terms);
    let currency_symbol = props.currency;
    currency_symbol = getCurrencySymbol(price && price.currency ? price.currency : null);
    let isSelected = priceSelected && priceSelected.id === price.id ? true : false;

    return (
        <Grid item className={classNames([classes.priceItem, isSelected ? classes.priceItemSelected : undefined])}>
            <CustomTypo center mg_top_xs variant='subtitle2' color={isSelected ? 'onPrimary' : undefined}>{currency_symbol}{price.price.toFixed(2)}</CustomTypo>
            {price_terms && price_terms.billing_period && <CustomTypo center mg_top_xs variant='body1' color={isSelected ? 'onPrimary' : undefined}>{mappingTerm(price_terms.billing_period)}</CustomTypo>}
        </Grid>
    );
}
function ProductImage(props) {
    var { classes, image } = props
    if (image && image.url) {
        return <img src={image.url} style={{ height: 100, width: '100%', borderTopLeftRadius: 4, borderTopRightRadius: 4, objectFit: 'contain' }} />
    } else {
        return <Grid item className={classes.item_image} />
    }
}
function mappingTerm(billing_period){
    let term = '';
    if(billing_period){
        if(billing_period.duration > 1){
            switch(billing_period.uot){
                case 'DAY': 
                    term = billing_period.duration + " " + t('day_title') + "s";
                    break;
                case 'MONTH': 
                    term = billing_period.duration + " " + t('month_label') + "s";
                    break;
                case 'YEAR': 
                    term = billing_period.duration + " " + t('year_title') + "s";
                    break;
                default: 
                    term = billing_period.duration + " " + billing_period.uot;
                    break;
            }
        } else {
            switch(billing_period.uot){
                case 'DAY': 
                    term = billing_period.duration + " " + t('day_title');
                    break;
                case 'MONTH': 
                    term = billing_period.duration + " " + t('month_label');
                    break;
                case 'YEAR': 
                    term = billing_period.duration + " " + t('year_title');
                    break;
                default: 
                    term = billing_period.duration + " " + billing_period.uot;
                    break;
            }
        }
    }
    return term;
}

export default withStyles(styles)(withTranslation()(ProductsView));